import { kaapApiRef, useAzureToken } from '@internal/backstage-plugin-kaap';
import { useAsync } from 'react-use';

import { useApi } from '@backstage/core-plugin-api';

export const useGetKaapApplications = () => {
  const kaapApi = useApi(kaapApiRef);
  const { getToken } = useAzureToken();

  const {
    value: applications,
    loading,
    error,
  } = useAsync(async () => {
    const { token } = await getToken();
    return kaapApi.getApplications(token);
  }, []);

  return { value: applications, loading, error };
};
